module.exports = __webpack_public_path__ + "static/media/video.bb7fece1.svg";